import { useEffect, useState } from 'react';

export function usePopupPosition(
    inputRef: React.RefObject<HTMLElement>,
    show: boolean,
    threshold: number = 400,
    horizontalThreshold: number = 100
) {
    const [position, setPosition] = useState<{ vertical: 'top' | 'bottom'; horizontal: 'left' | 'right' }>({
        vertical: 'bottom',
        horizontal: 'left',
    });

    useEffect(() => {
        if (inputRef.current && show) {
            const calculatePosition = () => {
                const inputRect = inputRef.current!.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                const viewportWidth = window.innerWidth;

                // Determine vertical position
                const vertical = inputRect.bottom + threshold > viewportHeight ? 'top' : 'bottom';

                // Determine horizontal position
                const distanceFromRight = viewportWidth - inputRect.right;
                const horizontal = distanceFromRight < horizontalThreshold ? 'right' : 'left';

                setPosition({ vertical, horizontal });
            };

            calculatePosition(); // Recalculate position on mount or when `show` changes

            window.addEventListener('resize', calculatePosition); // Recalculate on resize
            return () => {
                window.removeEventListener('resize', calculatePosition);
            };
        }
    }, [inputRef, show, threshold, horizontalThreshold]); // Recalculate when dependencies change

    useEffect(() => {
        const disableBodyScroll = () => {
            if (show && window.innerWidth < 768) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        };

        disableBodyScroll(); // Set scroll behavior initially

        return () => {
            document.body.style.overflow = ''; // Clean up on unmount or when `show` becomes false
        };
    }, [show]); // Re-run when `show` changes

    return position;
}
